import Repository from '@/repositories/RepositoryFactory';
import ENUM from '../../enums/APISTATE';
import store from '../';


export default {
    namespaced: true,
    state: {
        errorModalOpen: false,
        errorModalText: '',
        confirmationButtonText: '',
        confirmed: undefined,
        errorModalHeader: '',
        confirmingModel: {},
    },
    mutations: {
        setErrorModalOpen (state, open){
            state.errorModalOpen = open
        },
        setErrorModalText (state, text) {
            state.errorModalText = text
        },
        setErrorModalHeader (state, header) {
            state.errorModalHeader = header
        },
        setConfirmationButtonText(state, confirmationText){
            state.confirmationButtonText = confirmationText
        },
        setConfirmed(state, confirmed){
            console.log(confirmed);
            state.confirmed = confirmed
        },
        setConfirmingModel(state, confirmingModel){
            state.confirmingModel = confirmingModel;
        }
    },
    actions: {
        setErrorModalOpen: ({commit},  open) => {commit("setErrorModalOpen", open)},
        setErrorModalText: ({commit},  text) => {commit("setErrorModalText", text)},
        setConfirmationButtonText: ({commit},  confrimationText) => {commit("setConfirmationButtonText", confrimationText)},
        setConfirmedAndClose: ({commit}, confirmed) => {
            commit("setErrorModalOpen", false)
            commit("setConfirmed", confirmed)
        },
        setConfirmed: ({commit}, confirmed) => {commit("setConfirmed", confirmed)}, 
        setErrorModalHeader: ({commit}, header) => {commit("setErrorModalHeader", header)},
        setConfirmingModel({commit}, confirmingModel){commit("setConfirmingModel", confirmingModel)}
    },
    getters: {
        errorModalOpen: (state) => {return state.errorModalOpen},
        errorModalText: (state) => {return state.errorModalText},
        confirmationButtonText: (state) => {return state.confirmationButtonText},
        confirmed: (state) => {return state.confirmed},
        errorModalHeader: (state) => {return state.errorModalHeader},
        confirmingModel: (state) => {return state.confirmingModel}
    }

}